import { defineComponent as _defineComponent } from 'vue'
import { toRefs } from '@nuxtjs/composition-api';
import type { Props as IconProps } from '~/core/components/base/image/SvgThemedIcon.vue';
import type { DefineComponent } from 'vue';

interface Props {
    tag?: string | DefineComponent,
    icon?: IconProps,
    theme?: 'light' | 'dark',
    disabled?: boolean,
    styling?: 'primary' | 'secondary' | 'tertiary' | 'quaternary',
    size?: 'l' | 'm' | 's',
}
export default /*#__PURE__*/_defineComponent({
  __name: 'Close',
  props: {
    tag: { default: 'button' },
    icon: { default: () => ({
        name: 'close',
        path: 'actions',
    }) },
    theme: null,
    disabled: { type: Boolean },
    styling: { default: 'primary' },
    size: { default: 'm' }
  },
  setup(__props: any) {

const props = __props as { tag: string | DefineComponent, icon: IconProps, theme?: 'light' | 'dark', disabled?: boolean, styling: 'primary' | 'secondary' | 'tertiary' | 'quaternary', size: 'l' | 'm' | 's' };

;



const {
    tag,
    theme,
    disabled,
    styling,
    size,
    icon,
} = toRefs(props);

return { __sfc: true,props, tag, theme, disabled, styling, size, icon }
}

})